//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState } from 'react';

// === STYLES ===
import { useTheme } from '@mui/material/styles';
import {
  Checkbox,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
} from '@mui/material';
import {
  Edit,
  VpnKey,
  GroupAdd,
  PersonAddDisabled,
} from '@mui/icons-material';

// === COMPONENTS ===
import { UserRoles } from './UserRoles';
import { EditUserDialog } from '../EditUserDialog';

// === API ===
import { requestPasswordReset } from 'api/prokey/prokey.axios';

// === UTILS ===
import {getHexAlpha} from 'components/styles.utils';

//#endregion

//-----------------------------------------------------------------
export function UserRow({ user, roles, onSelected, modifyUser, is_selected=false }) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const [ assigned_roles     , setAssignedRoles      ] = useState( [] );
  const [ available_roles    , setAvailableRoles     ] = useState( [] );
  const [ showEditUsersModal , setShowEditUsersModal ] = useState( false );
  const [ selected           , setSelected           ] = useState( is_selected )

  const toggle_action = user.disabledAt ? 'enable' : 'disable';
  const toggle_icon   = user.disabledAt ? <GroupAdd /> : <PersonAddDisabled />;

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {

    }
  }

  const ROW = {

  }
  const EDIT_DIALOG = {
    user          : user,
    showDialog    : showEditUsersModal,
    setShowDialog : setShowEditUsersModal,
  }
  const EDIT_BUTTON = {
    color        : 'primary',
    ariaLabel    : 'edit-user',
    ariaControls : 'edit-user',
    onClick      : () => setShowEditUsersModal(true),
  }
  const RESET_BUTTON = {
    color        : 'primary',
    ariaLabel    : 'reset-user-pass',
    ariaControls : 'reset-user-pass',
    onClick      : () => requestPasswordReset( user.Id ),
  }
  const TOGGLE_BUTTON = {
    color        : 'primary',
    ariaLabel    : 'enable-disable-user',
    ariaControls : 'enable-disable-user',
    onClick      : () => modifyUser( toggle_action, user.Id ),
  }
  const ROLES = {
    userId         : user.Id,
    userRoles      : assigned_roles,
    availableRoles : available_roles,
  }

  //#endregion

  //#region [EFFECT]

  useEffect(() => {
    const user_roles      = user.roles;//.map((role) => role.RoleName);
    const assigned_roles  = roles.filter( (x) =>  user_roles.includes(x.RoleName) );
    const available_roles = roles.filter( (x) => !user_roles.includes(x.RoleName) );
    setAssignedRoles ( assigned_roles  );
    setAvailableRoles( available_roles );
  }, [user, roles]);

  useEffect( () => {
    setSelected( is_selected );
  }, [is_selected] );

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------

    const SelectionBox = displaySelectionBox;
    const   EditButton = displayEditButton; 
    const  ResetButton = displayResetButton;
    const ToggleButton = displayToggleButton;

    return (
      <TableRow sx={{ width: '100%', background: selected ? theme.palette.primary.main+getHexAlpha(50) : '' }} key={user.Id}>
        <TableCell sx={{border: 'none' }} ><SelectionBox /></TableCell>
        <TableCell sx={{border: 'none' }}>
          <EditUserDialog { ...EDIT_DIALOG } />
          <  EditButton />
          < ResetButton />
          <ToggleButton />
        </TableCell>
        <TableCell sx={{border: 'none' }} >{ user.Username       }</TableCell>
        <TableCell sx={{border: 'none' }} >{ user.FirstName      }</TableCell>
        <TableCell sx={{border: 'none' }} >{ user.LastName       }</TableCell>
        <TableCell sx={{border: 'none' }} >{ user.Email          }</TableCell>
        <TableCell sx={{border: 'none' }} >{ user.Company        }</TableCell>
        <TableCell sx={{border: 'none' }} >{ user.PasswordExpire }</TableCell>
        <UserRoles { ...ROLES } />
      </TableRow>
    );
  }

  //-----------------------------------------------------------------
  function displaySelectionBox() {
    //-----------------------------------------------------------------
    return (
      <Checkbox checked={selected} onChange={(event)=>{setSelected(event.target.checked);onSelected( user.Id, event.target.checked );}}/>
    )
  }

  //-----------------------------------------------------------------
  function displayEditButton() {
    //-----------------------------------------------------------------
    return (
      <Tooltip title='Edit User'>
        <IconButton { ...EDIT_BUTTON } >
          <Edit fontSize='small' />
        </IconButton>
      </Tooltip>
    )
  }
    
  //-----------------------------------------------------------------
  function displayResetButton() {
    //-----------------------------------------------------------------
    return (
      <Tooltip title='Reset User Password'>
        <IconButton { ...RESET_BUTTON } >
          <VpnKey fontSize='small' />
        </IconButton>
      </Tooltip>
    )
  }
    
  //-----------------------------------------------------------------
  function displayToggleButton() {
    //-----------------------------------------------------------------
    return (
      <Tooltip title='Enable/Disable User'>
        <IconButton { ...TOGGLE_BUTTON } >
          {toggle_icon}
        </IconButton>
      </Tooltip>
    )
  }

  //#endregion

  return display();
}
